import React from 'react';

const Terms = () => {
  return (
    <div className="max-w-4xl mx-auto px-4 py-12">
      <h1 className="text-4xl font-bold mb-6">Terms of Service</h1>
      <p className="text-gray-600 mb-8">Last updated: {new Date().toLocaleDateString()}</p>
      
      <div className="space-y-6">
        <section>
          <h2 className="text-2xl font-semibold mb-3">Acceptance of Terms</h2>
          <p className="text-gray-600">
            By using Fast Global Resume, you agree to these terms. If you don't agree, 
            please don't use our service.
          </p>
        </section>
        
        <section>
          <h2 className="text-2xl font-semibold mb-3">User Accounts</h2>
          <p className="text-gray-600">
            You are responsible for maintaining your account security. We're not liable 
            for unauthorized access to your account.
          </p>
        </section>
        
        <section>
          <h2 className="text-2xl font-semibold mb-3">Content Ownership</h2>
          <p className="text-gray-600">
            You own all content you create. We only use it to provide our service to you.
          </p>
        </section>
        
        <section>
          <h2 className="text-2xl font-semibold mb-3">Limitation of Liability</h2>
          <p className="text-gray-600">
            We provide our service "as is" and aren't liable for any damages resulting 
            from your use of our platform.
          </p>
        </section>
      </div>
    </div>
  );
};

export default Terms;